import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vacancies_feedbacks" }
const _hoisted_2 = { class: "flex itemscenter justify-between mt-6" }
const _hoisted_3 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feedbacks_actions = _resolveComponent("feedbacks-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_feedbacks_list_item = _resolveComponent("feedbacks-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_change_status_mode)
      ? (_openBlock(), _createBlock(_component_feedbacks_actions, {
          key: 0,
          loading: _ctx.state.is_change_status_loading,
          "initial-value": _ctx.state.initial_value,
          onChangeStatus: _ctx.changeStatus,
          onCancel: _ctx.cancelChangeStatus
        }, null, 8, ["loading", "initial-value", "onChangeStatus", "onCancel"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Отклики" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.state.is_failed && !_ctx.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.is_loading,
            text: "При получении списка откликов произошла ошибка",
            "error-message": _ctx.error_state.message,
            "error-url": _ctx.error_state.url,
            "error-status": _ctx.error_state.status,
            onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadFeedbacks(_ctx.pagination_state.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_list, {
            key: 1,
            loading: _ctx.state.is_loading,
            items: _ctx.state.feedbacks,
            pagination: "",
            "pagination-current-page": _ctx.pagination_state.current_page,
            "pagination-limit": _ctx.pagination_state.limit,
            "pagination-total-items": _ctx.pagination_state.total_items,
            "pagination-total-pages": _ctx.pagination_state.total_pages,
            onChangePage: _ctx.loadFeedbacks
          }, {
            item: _withCtx(({ item, index }) => [
              _createVNode(_component_feedbacks_list_item, {
                item: item,
                index: index,
                onChangeStatus: _ctx.startChangeStatus,
                onArchive: _ctx.onArchive,
                onUnarchive: _ctx.onUnarchive
              }, null, 8, ["item", "index", "onChangeStatus", "onArchive", "onUnarchive"])
            ]),
            _: 1
          }, 8, ["loading", "items", "pagination-current-page", "pagination-limit", "pagination-total-items", "pagination-total-pages", "onChangePage"]))
    ])
  ]))
}